// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-section {
    margin-top: 50px;
    margin-bottom: 10px;
}


.custom-container {
    min-height: 400px;
    /*padding-left: 8%;*/
    /*padding-right: 8%;*/
}

.rsult-btn a {
    display: inline-block;
    cursor: pointer;
    border-radius: 0;
    font-size: 14px;
    font-weight: 500;
    border: none;
}

.rsult-btn a.active_type {
    border-top: 3px solid rgba(108, 47, 187, 1);
    color: rgba(108, 47, 187, 1);
}

.rsult-btn a:hover {
    color: #6c2fbb;
}

.rsult-btn a:first-child {
    border-right: 1px solid #ccc;
}

.custom-container h5 {
    font-size: 20px;
    margin-bottom: 0;
}

.custom-container p {
    color: #a6a3a3;
    font-size: 14px;
}

.custom-container p > span {
    color: #6e5eff;
}

.like-cmt-select > select {
    height: 50px;
    font-size: 15px;
    border: none !important;
    border-bottom: 1px solid #dbdbdb !important;
    border-radius: 0;
}

.like-cmt-select > span {
    position: absolute;
    font-size: 13px;
    left: 30px;
    top: 2px;
    color: #878787;
}

.like-cmt-select button span {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.like-cmt-select button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}

.like-cmt-select button.sort-videos {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    /* left: 117px; */
    top: 25px;
    padding: 0;
    width: 26px;
    background-color: #f5f7f6;
}

.like-cmt-select > label {
    position: absolute;
    font-size: 15px;
    left: 30px;
    top: 15px;
    color: #878787;
}

.filter-btn {
    background-color: transparent;
    height: 50px;
    width: 100%;
    box-shadow: none;
    border-radius: 3px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
}

.img-cover {
    position: relative;
}

.over {
    position: absolute;
    background-color: #000000;
    opacity: 0.7;
    top: 10px;
    right: 22px;
    color: #FFF;
}

.over img {
    margin-right: 5px;
}

.over span {
    margin-right: 10px;
}

.filter-btn img {
    height: 17px;
}

.filter-btn span {
    margin-right: 10px;
}

.info span {
    margin-right: 10px;
    font-size: 13px;
}

.info span.categories {
    color: #878787;
    font-size: 12px;
}

.video-container {
    padding-top: 15px;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.video-container:hover {
    background-color: #FFF;
}

.video-container:hover .published-options {
    display: block;

}

.video-container:hover .published-options p,
.video-container:hover .published-options h5 {
    color: #878787;
}

.video-container:hover .published-views {
    display: none;
}

.published-options {
    /*display: none;*/
    list-style-type: none;
    margin-bottom: 0;
}
.published-options li {
    padding: 5px 10px;
}

.published-options li a:hover {
    color: #6c2fbb;
}

.published-options p, h5 {
    color: #000000;
}

.published-options p {
    margin-bottom: 0px;
    margin-top: 0;
}

.published-options h5 {
    margin-top: 0;
    margin-bottom: 35px;
}

.published-views {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.published-views li {
    display: inline-block;
    margin-right: 15px;
}

.draft-row {
    margin-bottom: 70px;
}

h5 {
    margin-bottom: 10px;
}

/*.poster {*/
/*    width: 100%;*/
/*    !* height: 100%; *!*/
/*    cursor: pointer;*/
/*}*/

.video-img-box {
    display: flex;
    justify-content: center;
    /*height: 150px;*/
    position: relative;
    overflow: hidden;
    /* background: #ededed; */
    width: 100%;
}

.video-img-box img {
    aspect-ratio: 257/145;
    border-radius: 16px;
    object-fit: cover;
    cursor: pointer;
    /*padding: 10px;*/
}

@media (max-width: 1400px) {
    .video-img-box {
        height: 175px
    }
}

@media (max-width: 768px) {
    .video-img-box {
        height: 213px
    }
}

/*@media (max-width: 1024px) {*/
/*    .video-img-box {*/
/*        height: 145px*/
/*    }*/
/*}*/

.user-img-box {
    /* min-width: 70px;
    width: 70px;
    height: 70px;
    overflow: hidden;
    border-radius: 13px; */

    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 4px;
    margin: auto;
}

.user-img-box img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: cover;
}

.filters-div {
    display: none;
    width: 100%;
    height: auto;
    background-color: #FFF;
    padding-top: 15px;
    padding-bottom: 15px;
    margin-bottom: 40px;
    box-shadow: 0px 0px 10px 0px #dad8d8;
}

.filters-div h5 {
    margin-top: 10px;
    font-size: 15px;
    margin-bottom: 10px;
}

.filters-div label {
    font-size: 14px;
}

.filters-div input.minMax {
    height: 30px;
}

.filters-div label.form-header {
    margin-bottom: 5px;
}

.filters-div button.btn-apply {
    height: 30px;
    color: #fff;
    background-color: #6e5eff;
    border-color: #6e5eff;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 15px;
}

.search-result {
    border-radius: 10px;
    margin-bottom: 20px;
    padding-top: 15px;
    padding-bottom: 15px;
    /* background-color: #FFF;
    box-shadow: 0 0 10px 0 #dad8d8; */
    padding-left: 20px;
}

.search-result:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
}

/* .search-result :hover {

} */

.search-result img.poster {
    width: 100%;
    object-fit: cover;
    height: 160px;
}

.search-result img.user {
    width: 40px;
    height: 40px;
    /* border-radius: 50%; */
    border-radius: 4px;
    object-fit: cover;
}

.search-result h5 {
    margin-top: 0;
}

.search-result span.video-stats {
    margin-right: 15px;
    word-break: break-all;
    font-size: 13px;
}

.search-section p.video-desc {
    margin-top: 10px;
    margin-bottom: 0;
}

.search-result span.video-cat {
    margin-right: 10px;
    border-radius: 4px;
}

.profile-image{
        /* padding-top: 10px; */
        width: 40px;
        height: 40px;
        /* margin-right: 10px; */
        margin: auto;
        text-align: center;
        color: #ffffff;
        background: #bd50d0;
        border-radius: 4px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: 600;
        vertical-align: middle;
        text-transform: uppercase;
        /* line-height: 40px; */
        line-height: 50px;
        text-decoration: none;
}

.videoSection{
    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: white;
    border-radius: 16px;
    padding-top: 15px;
    height: auto !important;
}
.community{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.userSection{
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 15px;
    height: auto !important;
}

@media (max-width: 991px) {
    .search-result h5 {
        margin-top: 15px;
    }

    .rsult-btn, .like-cmt-select {
        margin-bottom: 15px;
    }

    .rsult-btn h5 {
        margin-left: 0px !important;
    }

    .filter-btn {
        text-align: left;
    }

    .filter-btn img {
        margin-left: 15px;
    }

    .custom-container {
        margin-bottom: 100px;
    }
}


/* table css */

tr.hide-table-padding td {
    padding: 0;
}

.expand-button {
    position: relative;
    cursor: pointer;
    border: none !important;
}

.accordion-toggle .expand-button:after {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translate(0, -50%);
    content: "-";
}

.accordion-toggle.collapsed .expand-button:after {
    content: ">";
}

.bg-change1,
.bg-change2,
.bg-change3,
.bg-change4,
.bg-change5,
.bg-change6 {
    background-color: #6c2fbb !important;
    color: white;
}

table {
    border: 2px #cecece solid;
    border-collapse: collapse;
}

table td {
    border-left: 1px solid #80808078;
}

table th {
    border-left: 1px solid #80808078;
}

#anlyticsModal {
    overflow-y: hidden !important;
    max-height: 635px !important;
    padding-bottom: 15px !important;
}

table td:first-child {
    border-left: none;
}

.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    cursor: pointer;
}

.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.reaction-img {
    margin: 0px 5px;
}

.modal-body {
    overflow: scroll;
    height: 462px !important;
    /* max-height: auto; */
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/new-search-results/new-search-results.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;;AAElB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ,mBAAmB;AACnB,0BAA0B;AAC1B,uBAAuB;AACvB,IAAI;;AAEJ;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA,+BAA+B;AAC/B,uBAAuB;AACvB,wBAAwB;AACxB,QAAQ;AACR,IAAI;;AAEJ;IACI;;;;0BAIsB;;IAEtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IAEf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;qCACiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;QACQ,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,YAAY;QACZ,kBAAkB;QAClB,cAAc;QACd,mBAAmB;QACnB,6BAA6B;QAC7B,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,uBAAuB;QACvB,iBAAiB;QACjB,qBAAqB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;;AAGA,cAAc;;AAEd;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;IAMI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":[".search-section {\n    margin-top: 50px;\n    margin-bottom: 10px;\n}\n\n\n.custom-container {\n    min-height: 400px;\n    /*padding-left: 8%;*/\n    /*padding-right: 8%;*/\n}\n\n.rsult-btn a {\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 0;\n    font-size: 14px;\n    font-weight: 500;\n    border: none;\n}\n\n.rsult-btn a.active_type {\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    color: rgba(108, 47, 187, 1);\n}\n\n.rsult-btn a:hover {\n    color: #6c2fbb;\n}\n\n.rsult-btn a:first-child {\n    border-right: 1px solid #ccc;\n}\n\n.custom-container h5 {\n    font-size: 20px;\n    margin-bottom: 0;\n}\n\n.custom-container p {\n    color: #a6a3a3;\n    font-size: 14px;\n}\n\n.custom-container p > span {\n    color: #6e5eff;\n}\n\n.like-cmt-select > select {\n    height: 50px;\n    font-size: 15px;\n    border: none !important;\n    border-bottom: 1px solid #dbdbdb !important;\n    border-radius: 0;\n}\n\n.like-cmt-select > span {\n    position: absolute;\n    font-size: 13px;\n    left: 30px;\n    top: 2px;\n    color: #878787;\n}\n\n.like-cmt-select button span {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #555;\n    display: inline-block;\n}\n\n.like-cmt-select button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 16px;\n    top: 25px;\n    width: 50px;\n    background-color: #f5f7f6;\n}\n\n.like-cmt-select button.sort-videos {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    /* left: 117px; */\n    top: 25px;\n    padding: 0;\n    width: 26px;\n    background-color: #f5f7f6;\n}\n\n.like-cmt-select > label {\n    position: absolute;\n    font-size: 15px;\n    left: 30px;\n    top: 15px;\n    color: #878787;\n}\n\n.filter-btn {\n    background-color: transparent;\n    height: 50px;\n    width: 100%;\n    box-shadow: none;\n    border-radius: 3px;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 6px;\n}\n\n.img-cover {\n    position: relative;\n}\n\n.over {\n    position: absolute;\n    background-color: #000000;\n    opacity: 0.7;\n    top: 10px;\n    right: 22px;\n    color: #FFF;\n}\n\n.over img {\n    margin-right: 5px;\n}\n\n.over span {\n    margin-right: 10px;\n}\n\n.filter-btn img {\n    height: 17px;\n}\n\n.filter-btn span {\n    margin-right: 10px;\n}\n\n.info span {\n    margin-right: 10px;\n    font-size: 13px;\n}\n\n.info span.categories {\n    color: #878787;\n    font-size: 12px;\n}\n\n.video-container {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n}\n\n.video-container:hover {\n    background-color: #FFF;\n}\n\n.video-container:hover .published-options {\n    display: block;\n\n}\n\n.video-container:hover .published-options p,\n.video-container:hover .published-options h5 {\n    color: #878787;\n}\n\n.video-container:hover .published-views {\n    display: none;\n}\n\n.published-options {\n    /*display: none;*/\n    list-style-type: none;\n    margin-bottom: 0;\n}\n.published-options li {\n    padding: 5px 10px;\n}\n\n.published-options li a:hover {\n    color: #6c2fbb;\n}\n\n.published-options p, h5 {\n    color: #000000;\n}\n\n.published-options p {\n    margin-bottom: 0px;\n    margin-top: 0;\n}\n\n.published-options h5 {\n    margin-top: 0;\n    margin-bottom: 35px;\n}\n\n.published-views {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.published-views li {\n    display: inline-block;\n    margin-right: 15px;\n}\n\n.draft-row {\n    margin-bottom: 70px;\n}\n\nh5 {\n    margin-bottom: 10px;\n}\n\n/*.poster {*/\n/*    width: 100%;*/\n/*    !* height: 100%; *!*/\n/*    cursor: pointer;*/\n/*}*/\n\n.video-img-box {\n    display: flex;\n    justify-content: center;\n    /*height: 150px;*/\n    position: relative;\n    overflow: hidden;\n    /* background: #ededed; */\n    width: 100%;\n}\n\n.video-img-box img {\n    aspect-ratio: 257/145;\n    border-radius: 16px;\n    object-fit: cover;\n    cursor: pointer;\n    /*padding: 10px;*/\n}\n\n@media (max-width: 1400px) {\n    .video-img-box {\n        height: 175px\n    }\n}\n\n@media (max-width: 768px) {\n    .video-img-box {\n        height: 213px\n    }\n}\n\n/*@media (max-width: 1024px) {*/\n/*    .video-img-box {*/\n/*        height: 145px*/\n/*    }*/\n/*}*/\n\n.user-img-box {\n    /* min-width: 70px;\n    width: 70px;\n    height: 70px;\n    overflow: hidden;\n    border-radius: 13px; */\n\n    width: 40px;\n    height: 40px;\n    overflow: hidden;\n    border-radius: 4px;\n    margin: auto;\n}\n\n.user-img-box img {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n.filters-div {\n    display: none;\n    width: 100%;\n    height: auto;\n    background-color: #FFF;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    margin-bottom: 40px;\n    box-shadow: 0px 0px 10px 0px #dad8d8;\n}\n\n.filters-div h5 {\n    margin-top: 10px;\n    font-size: 15px;\n    margin-bottom: 10px;\n}\n\n.filters-div label {\n    font-size: 14px;\n}\n\n.filters-div input.minMax {\n    height: 30px;\n}\n\n.filters-div label.form-header {\n    margin-bottom: 5px;\n}\n\n.filters-div button.btn-apply {\n    height: 30px;\n    color: #fff;\n    background-color: #6e5eff;\n    border-color: #6e5eff;\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 15px;\n}\n\n.search-result {\n    border-radius: 10px;\n    margin-bottom: 20px;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    /* background-color: #FFF;\n    box-shadow: 0 0 10px 0 #dad8d8; */\n    padding-left: 20px;\n}\n\n.search-result:hover {\n    background-color: #f8f9fa;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);\n}\n\n/* .search-result :hover {\n\n} */\n\n.search-result img.poster {\n    width: 100%;\n    object-fit: cover;\n    height: 160px;\n}\n\n.search-result img.user {\n    width: 40px;\n    height: 40px;\n    /* border-radius: 50%; */\n    border-radius: 4px;\n    object-fit: cover;\n}\n\n.search-result h5 {\n    margin-top: 0;\n}\n\n.search-result span.video-stats {\n    margin-right: 15px;\n    word-break: break-all;\n    font-size: 13px;\n}\n\n.search-section p.video-desc {\n    margin-top: 10px;\n    margin-bottom: 0;\n}\n\n.search-result span.video-cat {\n    margin-right: 10px;\n    border-radius: 4px;\n}\n\n.profile-image{\n        /* padding-top: 10px; */\n        width: 40px;\n        height: 40px;\n        /* margin-right: 10px; */\n        margin: auto;\n        text-align: center;\n        color: #ffffff;\n        background: #bd50d0;\n        border-radius: 4px !important;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 22px;\n        font-weight: 600;\n        vertical-align: middle;\n        text-transform: uppercase;\n        /* line-height: 40px; */\n        line-height: 50px;\n        text-decoration: none;\n}\n\n.videoSection{\n    max-height: 700px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background-color: white;\n    border-radius: 16px;\n    padding-top: 15px;\n    height: auto !important;\n}\n.community{\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n.userSection{\n    max-height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-top: 15px;\n    height: auto !important;\n}\n\n@media (max-width: 991px) {\n    .search-result h5 {\n        margin-top: 15px;\n    }\n\n    .rsult-btn, .like-cmt-select {\n        margin-bottom: 15px;\n    }\n\n    .rsult-btn h5 {\n        margin-left: 0px !important;\n    }\n\n    .filter-btn {\n        text-align: left;\n    }\n\n    .filter-btn img {\n        margin-left: 15px;\n    }\n\n    .custom-container {\n        margin-bottom: 100px;\n    }\n}\n\n\n/* table css */\n\ntr.hide-table-padding td {\n    padding: 0;\n}\n\n.expand-button {\n    position: relative;\n    cursor: pointer;\n    border: none !important;\n}\n\n.accordion-toggle .expand-button:after {\n    position: absolute;\n    left: 0.75rem;\n    top: 50%;\n    transform: translate(0, -50%);\n    content: \"-\";\n}\n\n.accordion-toggle.collapsed .expand-button:after {\n    content: \">\";\n}\n\n.bg-change1,\n.bg-change2,\n.bg-change3,\n.bg-change4,\n.bg-change5,\n.bg-change6 {\n    background-color: #6c2fbb !important;\n    color: white;\n}\n\ntable {\n    border: 2px #cecece solid;\n    border-collapse: collapse;\n}\n\ntable td {\n    border-left: 1px solid #80808078;\n}\n\ntable th {\n    border-left: 1px solid #80808078;\n}\n\n#anlyticsModal {\n    overflow-y: hidden !important;\n    max-height: 635px !important;\n    padding-bottom: 15px !important;\n}\n\ntable td:first-child {\n    border-left: none;\n}\n\n.arrow {\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    display: inline-block;\n    padding: 3px;\n    cursor: pointer;\n}\n\n.right {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n}\n\n.reaction-img {\n    margin: 0px 5px;\n}\n\n.modal-body {\n    overflow: scroll;\n    height: 462px !important;\n    /* max-height: auto; */\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
